import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import Blamable            from '@/models/traits/Blamable';
import { Addable }         from '@widesk-core/decorators/addable';
import { Editable }        from '@widesk-core/decorators/editable';
import { Deletable }       from '@widesk-core/decorators/deletable';
import { Timestampable }   from '@widesk-core/decorators/timestampable';

@doc.path('/partnership_types/{?id}')
@doc.addable
@doc.editable
@doc.deletable
@doc.timestampable
abstract class AbstractPartnershipTypeModel extends Blamable(
	WebsiteServiceModel,
) {
	declare protected _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'position': string;
	};

	declare private _tsSorts: {
		id: string;
		position: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.number declare position: number;
}

interface AbstractPartnershipTypeModel
	extends Addable,
		Editable,
		Deletable,
		Timestampable {}

export default AbstractPartnershipTypeModel;
